import { Injectable } from '@angular/core';
import { Observable, Subject, Subscription } from 'rxjs';
import { filter, map } from 'rxjs/operators';

export interface Event {
    key: string;
    value: any;
}

@Injectable({
    providedIn: 'root'
})
export class EventService {
    private eventSubject = new Subject<Event>();
    private subscriptionsMap = new Map<string, Subscription[]>();

    public broadcast(key: string, value: any): void {
        this.eventSubject.next({ key, value });
    }

    public on<T>(key: string): Observable<T> {
        const observable = this.eventSubject.asObservable().pipe(
            filter(e => e.key === key),
            map(e => e.value)
        );

        return new Observable<T>(subscriber => {
            const sub = observable.subscribe(subscriber);

            if (!this.subscriptionsMap.has(key)) {
                this.subscriptionsMap.set(key, []);
            }
            this.subscriptionsMap.get(key)!.push(sub);

            return () => {
                sub.unsubscribe();
                this.removeSubscription(key, sub);
            };
        });
    }

    public unsubscribeAllEvents(keys: string[]): void {
        keys.forEach(key => {
            const subs = this.subscriptionsMap.get(key);
            if (subs) {
                subs.forEach(sub => sub.unsubscribe());
                this.subscriptionsMap.delete(key);
            }
        });
    }

    private removeSubscription(key: string, sub: Subscription): void {
        const subs = this.subscriptionsMap.get(key);
        if (subs) {
            const updated = subs.filter(s => s !== sub);
            if (updated.length > 0) {
                this.subscriptionsMap.set(key, updated);
            } else {
                this.subscriptionsMap.delete(key);
            }
        }
    }
}